import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getBlogsList } from '../../networkCalls'
import FotterMain from '../BaseComponents/FotterMain'
import Header from '../BaseComponents/Header'
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage'
import parse from 'html-react-parser';
import SEO from '../BaseComponents/SEO'
import { Pagination } from '@mui/material'
const BlogListing = () => {
    const [loading, setLoading] = useState(false);
    const [page, setPage] = React.useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [resultData, setResultData] = React.useState([]);
    const pullPressReleaseApi = () => {
        var data = new FormData();
        data.append('page', 1);
        setLoading(true);
        getBlogsList(data).then((res) => {
            setLoading(false);
            console.log('getBlogsList', res)
            switch (res.data.status) {
                case 1:
                    setResultData(res?.data?.blogsList)
                    setPageCount(res?.data?.TotalPaginatuon);
                    //setErrMessage('');
                    return true;
                case 0:
                    setResultData([]);
                    break;
                default:
                    return;
            }
        })
    }
    const toTop = () => {
        window.scrollTo(0, 0);
    }
    const handleChange = (event, value) => {
        setPage(value);
    };
    useEffect(() => {
        toTop();
        pullPressReleaseApi();
    }, [page]);
    
    return (
        <>
            <SEO
                title="Honda Blog | Honda India Power Products"
                description="Honda India Power Products Blog"
                name="HIPP - Honda India Power"
                url="https://www.hondaindiapower.com/blog"
                type='Website' />
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <>
                <div className='innerpagebg pt-5 pb-5'>
                    <div className='container mb-4'>
                        <div className='row'>
                            <div className='col-12  m-auto'>
                                <div className="align-items-center text-center">
                                    <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                        <span className='txtred'>Blog</span> <span className='txtdgray'></span>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='container'>
                        {resultData && resultData?.length > 0 ? <>
                            <div className='row'>
                                {resultData && resultData?.map(data =>
                                    <div key={data?.id} className='col-lg-10 col-md-12 col-12 m-auto'>
                                        <div className="post-card mb-4 p-3">
                                            <div className='row'>
                                                {data?.slug != '' ? <>
                                                    <div className='col-12 col-md-4'>
                                                        <Link to={`/blog/${data?.slug}`}>
                                                            <img alt="" className='img-fluid' src={data?.image} />
                                                        </Link>
                                                    </div>
                                                </> : <></>}
                                                <div className={`${data?.slug != ''}` ? 'col-12 col-md-8' : 'col-12'}>
                                                    <div className="mb-0">
                                                        <h2 className='mb-1 f16'><Link to={`/blog/${data?.slug}`} className='txtdgray'>{data?.title}</Link></h2>
                                                    </div>
                                                    <div className="mb-3 f13"><span className='txtlgeay'>{data?.author != '' ? <>By {data?.author} on </> : <>'</>}{data?.publishDate}</span></div>
                                                    <div className='text-muted'>{data?.shortDesc}</div>
                                                    <div className="post-card__date f12 mt-3"><Link to={`/blog/${data?.slug}`} className='txtred'>MORE...</Link></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </> : <>
                            <div className='row'>
                                <div className='col-lg-10 col-md-12 col-12  m-auto'>
                                    <div className='card text-center p-4'>
                                        No Records Found
                                    </div>
                                </div>
                            </div>
                        </>}
                        <div className='row'>
                            <div className='col-lg-10 col-md-12 col-12 m-auto text-end '>
                                <div className='d-flex justify-content-end'>
                                    <Pagination color='secondary' variant="outlined" count={pageCount} page={page} onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            <FotterMain />
        </>
    )
}

export default BlogListing